import { CustomObject } from './../../risk/components/raise-risk/raise-risk.component';
import { ElementRef, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { ConstantsService } from './constants.service';
import { Subject, Observable } from 'rxjs';
import { IndependentPermissions } from '../models/IndependentPermissions.model';
import { TranslateService } from '@ngx-translate/core';

declare var moment: any;

@Injectable()
export class BaseService {
  closePopup: boolean | undefined;
  public setClosePopUpListener = new Subject<any>();

  constructor(private router: Router) {
    this.dataForLineGraph = [];
    this.commonPermissions = new IndependentPermissions();
  }
  // Common global variables
  public showRootLoader = false;
  public loggedInUserType = '';
  public dateFormatDDMMYYYY = 'dd MMM yyyy';
  public dateFormatDDMMYYYYHHMMSS = 'dd MMM yyyy HH:mm a';
  public routesFlag: any[] | undefined;
  public reportRoutes: any[] | undefined;
  public dataForLineGraph: CustomObject[];
  public unitListner = new Subject<any>();
  public commonPermissions: IndependentPermissions;
  public SelectedInspectionId: number = 0;
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home, delete
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete'];

  public translate: TranslateService | undefined;
  public translatorListener = new Subject<any>();
  /**
    * Function to get item from session.
    * @param key - Key of item to be fetched
    */
  getItemFromSession(key: any): any {
    return localStorage.getItem(key);
  }

  /**
    * Function to set item in session.
    * @param key - Key of item to be stored
    * @param value - Value of item to be stored in string
    */
  setItemInSession(key: string, value: any) {
    return localStorage.setItem(key, value);
  }

  public getSelectedUnitId(data: any) {
    this.unitListner.next(data);
  }
  /**
    * Function to set item in session.
    * @param key - Key of item to be removed
    */
  removeItemFromSession(key: string) {
    return localStorage.removeItem(key);
  }

  /**
   * Function to clear session of current logged in user
   */
  clearSession() {
    localStorage.clear();
  }

  /**
  * Function to get resource for endpoint
  * @param endpoint - Endpoint for which resource is to be fetched.
  */
  getResourceForEndpoint(endpoint: string | string[]) {
    // if user specified list of anonymous endpoints, no need to send token to these endpoints, return null.
    if (ConstantsService.ADALCONFIG.ANONYMOUS_ENDPOINTS) {
      const filteredAnonymousEndpoints = ConstantsService.ADALCONFIG.ANONYMOUS_ENDPOINTS.filter(function (element) {
        return -1 < endpoint.indexOf(element);
      });
      if (filteredAnonymousEndpoints && filteredAnonymousEndpoints.length) {
        return null;
      }
    }
    const loggedinUserType = this.getItemFromSession(ConstantsService.LoggedInUserType);

    if (loggedinUserType === ConstantsService.authenticationType.Employee) {
      const sessionConfig = this.getItemFromSession('adal-config');
      if (sessionConfig) {
        const config = JSON.parse(sessionConfig);
        for (const configEndpoint in config.endpoints) {
          if (-1 < endpoint.indexOf(configEndpoint)) {
            return config.endpoints[configEndpoint];
          }
        }
      }
    } else {
      return 'contractor login';
    }

    // if not the app's own backend or not a domain listed in the endpoints structure
    return null;
  }

  /**
    * Function to check valid text enter in fields
    * @param event - Get value of text fields
    * @param regex - Get regular expression based on validation
    */
  checkValidText(event: KeyboardEvent, regex: RegExp, el: ElementRef<any>) {
    // Allow Backspace, tab, end, home and Delete keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const current: string = el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(regex)) {
      event.preventDefault();
    }
  }

  /**
    * Process error response from API.
    */
  processApiResponseError(response: any) {
    this.showRootLoader = false;
    console.error(response);
  }

  /**
 * Function to navigate to url
 * @param: url - URL to navigate
 */
  navigateToUrl(url: string | UrlTree) {
    this.router.navigateByUrl(url);
  }
  navigateToLogOutUrl(url: string) {
    this.router.navigate(['/']).then(result => { window.location.href = url; });
  }

  navigateToCurrentURLRoute(url: string) {
    this.router.navigate(['/']).then(result => { window.location.href = url; });
  }
  /**
 * Function to get routesURL and reports routes
 * @param: routesFlag - routes URL
 * @param: reportRoutes - reports routes URL
 */
  setTopNavigationRoutes(routesFlag?: any[], reportRoutes?: any[]) {
    this.routesFlag = routesFlag;
    this.reportRoutes = reportRoutes;
  }

  /***
   * Set data for line graph
   */
  setDataForLine(data: any) {
    this.dataForLineGraph = [];
    this.dataForLineGraph = data;
  }

  /**
   * return data set from PEAR
   * @param data data set from PEAR
   */
  getDataForLine(): CustomObject[] {
    return this.dataForLineGraph;
  }
  public setPassRequestOutput(closePopup: boolean | undefined) {
    this.closePopup = closePopup;
  }

  public closePopUp(user: Event | undefined) {
    this.setClosePopUpListener.next(user);
  }

  public setCurrentLanguage(val: any) {
    this.translatorListener.next(val);
  }

  public getLocation(): Observable<any> {
    const locations = new Observable((observer) => {
      let watchId: number;
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position: any) => {
          observer.next(position);
        }, (error: any) => {
          observer.error(error);
        });
      } else {
        observer.error('Geolocation not available');
      }
    });
    return locations;
  }

  public getFilterData(key: string) {
    return sessionStorage.getItem(key);
  }
  
  public setFilterData(key: string, value: any) {
    sessionStorage.setItem(key, value);
  }

  public getUTCDate(dateToConvert: Date,isStart:boolean) {
    if ( dateToConvert && dateToConvert!=null )
    {
    var diffinMin=dateToConvert.getTimezoneOffset()*-1;
    if(isStart)
        dateToConvert= new Date(dateToConvert.setHours(0, 0, 0, 0));
    else 
        dateToConvert= new Date(dateToConvert.setHours(23, 59, 59, 0));
    
    dateToConvert.setMinutes(dateToConvert.getMinutes() + diffinMin);
    }
    return  dateToConvert;
     

  }
}
